(function($) {
	$(window).on("elementor/frontend/init", function() {});
})(jQuery);

const apiURL = "https://chaletdejuliette-gerardmer.fr/api/";

const initGalerie = () => {
	if (document.querySelector(".big_galerie")) {
		let laphoto = document.getElementById("laphoto");
		let images = document.querySelectorAll(".thumbs");
		let lagalerie = document.querySelector(".big_galerie");
		let bouton_galerie = document.querySelector(".bouton_galerie");
		let close_galerie = document.querySelector(".big_galerie .close");
		close_galerie.addEventListener("click", () => {
			lagalerie.classList.remove("active");
		});
		bouton_galerie.addEventListener("click", () => {
			lagalerie.classList.add("active");
		});
		images.forEach(item => {
			item.addEventListener("click", e => {
				images.forEach(el => {
					el.classList.remove("current");
				});
				e.currentTarget.classList.add("current");
				laphoto.classList.add("blurred");
				laphoto.style.backgroundImage = `url(${e.currentTarget.dataset.extra})`;
				setTimeout(() => {
					laphoto.classList.remove("blurred");
				}, 500);
			});
		});
		images[0].click();
	}
};
const initNote = () => {
	if (document.getElementById("lanote")) {
		var app = new Vue({
			el: "#comment_zone",
			data: {
				show_form: false,
				nom: "",
				email: "",
				idresa: "",
				synthese: "Fantastique !",
				note: 5,
				avis: "",
				texte_bouton: "Envoyer",
				notice: "Seuls les messages émanants d'un numéro de réservation valide seront mis en ligne."
			},
			mounted() {},
			methods: {
				handleSubmit() {
					this.texte_bouton = "<i class='fal fa-ellipsis-h'></i>";
					this.notice = "Un peu de patience, votre avis est en cours d'envoi.";
					axios({
						url: apiURL + "login/",
						method: "POST",
						params: {
							username: "lezardscreation",
							password: "Cmercuros88"
						}
					}).then(res => {
						this.texte_bouton = "<i class='fal fa-ellipsis-h'></i>";
						var obj = {
							custom_post: "appreciations",
							SESSION_ID: res.data.result[0].session_id,
							post_status: "draft",
							subject: this.nom + " : " + this.synthese,
							custom_field: {
								nom_de_lappreciateur: this.nom,
								email_de_lappreciateur: this.email,
								note_generale: this.note,
								synthese: this.synthese,
								details: this.avis,
								numero_de_reservation: this.idresa
							}
						};
						axios({
							url: apiURL + "newpost/",
							method: "POST",
							params: obj
						}).then(res2 => {
							console.log(res2);
							this.texte_bouton = "Merci !";
							this.notice = "<strong>Merci !</strong><br />Votre avis va être vérifié avant d'être publié.";
							setTimeout(() => {
								this.show_form = false;
							}, 2000);
						});
					});
				}
			}
		});
	}
};
const initTemoins = () => {
	if (document.getElementById("lescommentaires")) {
		Vue.component("paginate", VuejsPaginate);
		var commentaires = new Vue({
			el: "#lescommentaires",
			data: {
				count: 1,
				precedent: "Precédent",
				next: "Suivant",
				ready: false,
				avis: [],
				stillmore: false,
				nextpage: 1,
				pagecurrent: 1
			},
			created() {
				axios({
					url: apiURL + "getposts/",
					method: "POST",
					params: {
						custom_post: "appreciations",
						post_status: "publish",
						orderby: "postmeta.note_generale",
						perpage: 3
					}
				}).then(res => {
					this.ready = true;
					this.stillmore = res.data.paging.stillmore;
					this.count = res.data.paging.pages;
					this.avis = res.data.result;
					this.nextpage = res.data.paging.next;
				});
			},
			methods: {
				changePage() {
					this.ready = false;
					axios({
						url: apiURL + "getposts/",
						method: "POST",
						params: {
							custom_post: "appreciations",
							post_status: "publish",
							orderby: "postmeta.note_generale",
							perpage: 3,
							callpage: this.nextpage
						}
					}).then(res => {
						this.pagecurrent = this.nextpage;
						this.stillmore = res.data.paging.stillmore;
						this.count = res.data.paging.pages;
						this.avis = res.data.result;
						this.nextpage = res.data.paging.next;
						this.ready = true;
					});
				}
			}
		});
	}
};
const initActivites = () => {
	if (document.getElementById("les-activites")) {
		let filters = document.querySelectorAll("#les-activites .filters span");
		let activites = document.querySelectorAll("#les-activites .activite");
		filters.forEach(item => {
			item.addEventListener("click", () => {
				filters.forEach(el => {
					el.classList.remove("current");
				});
				item.classList.add("current");
				let target = item.dataset.cible;
				activites.forEach(a => {
					if (a.classList.contains(target)) {
						a.classList.remove("hidden");
					} else {
						a.classList.add("hidden");
					}
				});
			});
		});
	}
};
const initHeader = () => {
	let bouton = document.querySelector("#mobile_header .burger");
	let header = document.getElementById("mobile_header");
	bouton.addEventListener("click", () => {
		if (header.classList.contains("deploy")) {
			header.classList.remove("deploy");
		} else {
			header.classList.add("deploy");
		}
	});
};

window.addEventListener("DOMContentLoaded", () => {
	initGalerie();
	initNote();
	initTemoins();
	initActivites();
	initHeader();
	AOS.init({
		mirror: true
	});
});
